import { AppSettings } from "@/AppSettings";
import { useMemo } from "react";
import { createEventConfiguration } from "./useEventConfiguration";
import { ConfigurationSourceDataMap, Metadata, Trial } from "@/api/dtos";

const useEventConfigurations = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    trial?: Trial, 
    configurationSourceDataId?: number
) => {
    return useMemo(() => {
        if (!metadata || !metadata.events) {
            return undefined;
        }

        return Object.keys(metadata.events).map(studyEventOid => {
            return createEventConfiguration(
                metadata, 
                trialConfiguration?.events, 
                configuration?.events, 
                trial, 
                configuration?.configuration?.isGlobal,
                configuration?.configuration?.id ?? configurationSourceDataId, 
                studyEventOid
            );
        }).filter(x => !!x);
    }, [metadata, trialConfiguration?.events, configuration?.events, trial, configurationSourceDataId]) as Array<NonNullable<ReturnType<typeof createEventConfiguration>>> | undefined
};

export default useEventConfigurations;